import { LoadingButton } from '@mui/lab';
import { Box, Button, FormControlLabel, Grid, Switch } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { GeneralSelectMenu } from 'src/components/general';
import GeneralUpload from 'src/components/general/GeneralUpload';
import { networkCreateApplicationMenu, networkUpdateApplicationMenu } from 'src/network/application-menu';
import useFormsModalStore from 'src/store/forms';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import { SkeletonForm } from '../../components/skeleton';
import { getDefaultValues } from './defaultValues';

// ----------------------------------------------------------------------

const DEFAULT_THEME_VALUES = [
  { title: 'روشن', id: 1 },
  { title: 'تیره', id: 2 },
];

export default function SubIMenuItemForm() {
  const { modal, closeModal } = useFormsModalStore();

  const queryClient = useQueryClient();

  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const [selectedTheme, setSelectedTheme] = useState(1);

  const subMenuItemDetails = modal?.data;
  const isEditMode = subMenuItemDetails?.isEditMode;

  // -------------------------------------------------------

  const defaultValues = getDefaultValues(subMenuItemDetails);
  const methods = useForm({
    // resolver: yupResolver(schema), // todo
    defaultValues,
  });

  const {
    reset,
    trigger,
    handleSubmit,
    formState: { isSubmitting },
    setValue,
  } = methods;

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
      ApplicationMenuApplicationID: subMenuItemDetails?.ApplicationMenuApplicationID,
      ApplicationMenuApplicationMenuSectionID: subMenuItemDetails?.ApplicationMenuApplicationMenuSectionID,
      ApplicationMenuShowTextMenu: values?.ApplicationMenuShowTextMenu ? 1 : 0,
      ApplicationMenuApplicationThemeModeID: selectedTheme,
      ParentID: subMenuItemDetails?.ParentID,
    };

    try {
      if (isEditMode) {
        const res = await networkUpdateApplicationMenu(subMenuItemDetails?.SubApplicationMenuID, PAYLOAD);
        enqueueSnackbar('ویرایش با موفقیت انجام شد');
        if (event.nativeEvent.submitter.name === 'save') {
          closeModal();
          reset();
        }
      } else {
        const res = await networkCreateApplicationMenu(PAYLOAD);
        enqueueSnackbar('ثبت با موفقیت انجام شد');
        if (event.nativeEvent.submitter.name === 'save') {
          closeModal();
        }
        reset();
      }

      await queryClient.invalidateQueries({
        queryKey: [
          'application-menu-items',
          {
            AppID: subMenuItemDetails?.ApplicationMenuApplicationID,
            MenuSectionTypeID: subMenuItemDetails?.ApplicationMenuApplicationMenuSectionID,
          },
        ],
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            {isLoading ? (
              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)' },
                  width: '100%',
                }}
              >
                <SkeletonForm number={16} />
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                  }}
                >
                  <RHFTextField name="ApplicationMenuLable" type="text" label="عنوان" />

                  <RHFTextField name="ApplicationMenuUrl" type="text" label="لینک" />

                  <RHFTextField name="ApplicationMenuOrderIndex" type="text" label="ترتیب" />

                  <GeneralUpload
                    label="آیکون"
                    name="ApplicationMenuLogo"
                    afterChangeAction={(res) => {
                      setValue('ApplicationMenuLogo', res);
                      trigger('ApplicationMenuLogo');
                    }}
                  />

                  <GeneralSelectMenu
                    label="تم"
                    name="themeMode"
                    options={DEFAULT_THEME_VALUES}
                    value={selectedTheme}
                    onChangeValue={setSelectedTheme}
                  />

                  <FormControlLabel
                    name="ApplicationMenuShowTextMenu"
                    label={'آیا نمایش داده شود؟'}
                    control={
                      <Switch
                        checked={methods.watch('ApplicationMenuShowTextMenu')}
                        onChange={(e) => {
                          setValue('ApplicationMenuShowTextMenu', e.target.checked ? 1 : 0);
                          trigger('ApplicationMenuShowTextMenu');
                        }}
                      />
                    }
                  />
                </Box>

                <div className="flex items-center gap-4 mt-6">
                  <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                    ذخیره
                  </LoadingButton>
                  <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
                    {isEditMode ? 'ذخیره و ادامه ویرایش' : 'ذخیره و ایجاد بعدی'}
                  </LoadingButton>
                  <Button onClick={closeModal} variant="contained" color="error">
                    انصراف
                  </Button>
                </div>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
